import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';

const churchServiceListItem = {
  cfg: {
    name: 'churchServiceListItem',
    dialogId: 'churchServiceDialog',
    openBtnId: 'openDialog',
    closeBtnId: 'closeDialog',
  },

  toggleScrolling(containerEl, isStopped) {
    const drawer = containerEl.querySelector('[data-drawer]');

    if (containerEl && drawer) {
      if (isStopped) {
        disableBodyScroll(drawer);
      } else {
        enableBodyScroll(drawer);
      }
    }
  },

  updateUrl(newParamValue) {
    const url = new URL(window.location.href);
    if (newParamValue) {
      url.searchParams.set('gottesdienst-detail', newParamValue);
    } else {
      url.searchParams.delete('gottesdienst-detail');
    }
    window.history.pushState({}, '', url);
  },

  // Function to trap the focus inside the modal
  trapFocus(container) {
    const focusableElements = container.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    const onTabPress = (e) => {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
        }
      }
    };

    container.addEventListener('keydown', onTabPress);
    return () => container.removeEventListener('keydown', onTabPress);
  },

  openModal(container, drawer) {
    if (!container || !drawer) return;

    drawer.classList.remove('hidden');

    requestAnimationFrame(() => {
      container.setAttribute('data-state', 'open');
      drawer.setAttribute('data-state', 'open');

      const backdrop = container.querySelector('[data-backdrop]');
      if (backdrop) {
        backdrop.style.opacity = '0.15';
        backdrop.style.pointerEvents = 'auto';
      }

      this.toggleScrolling(container, true);

      // Focus on the close button when the modal opens
      const closeBtn = container.querySelector(`#${this.cfg.closeBtnId}--${container.id.split('--')[1]}`);
      if (closeBtn) {
        closeBtn.focus();
      }

      const removeFocusTrap = this.trapFocus(container);

      this.closeModal = () => {
        removeFocusTrap();
      };
    });
  },

  closeWithAnimation(container, drawer) {
    if (!container || !drawer) return;

    drawer.setAttribute('data-state', 'closed');
    container.setAttribute('data-state', 'closed');

    const backdrop = container.querySelector('[data-backdrop]');
    if (backdrop) {
      backdrop.style.opacity = '0';
      backdrop.style.pointerEvents = 'none';
    }

    setTimeout(() => {
      this.toggleScrolling(container, false);
      this.updateUrl('');

      if (this.closeModal) {
        this.closeModal();
      }
    }, 500); // Tailwind duration
  },

  checkUrlForModal() {
    const id = new URLSearchParams(window.location.search).get('gottesdienst-detail');
    if (!id) return;

    const container = document.getElementById(`${this.cfg.dialogId}--${id}`);
    const drawer = container?.querySelector('[data-state]');

    if (container && drawer) {
      this.openModal(container, drawer);
    }
  },

  init() {
    const openBtns = document.querySelectorAll(`[id^="${this.cfg.openBtnId}"]`);

    openBtns.forEach((btn) => {
      const id = btn.id.split('--')[1];
      const container = document.getElementById(`${this.cfg.dialogId}--${id}`);
      const drawer = container?.querySelector('[data-state]');
      const closeBtn = document.getElementById(`${this.cfg.closeBtnId}--${id}`);

      if (btn && container && drawer) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openModal(container, drawer);
          this.updateUrl(id);
        });
      }

      if (closeBtn && container && drawer) {
        closeBtn.addEventListener('click', () => this.closeWithAnimation(container, drawer));
      }

      if (container && drawer) {
        // Click outside closes
        container.addEventListener('click', (e) => {
          const rect = drawer.getBoundingClientRect();
          const clickedInside =
            rect.top <= e.clientY && e.clientY <= rect.bottom &&
            rect.left <= e.clientX && e.clientX <= rect.right;

          if (!clickedInside) {
            this.closeWithAnimation(container, drawer);
          }
        });

        // ESC key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && container.getAttribute('data-state') === 'open') {
            this.closeWithAnimation(container, drawer);
          }
        });
      }
    });

    this.checkUrlForModal();
  },
};

export default churchServiceListItem;
